import type { SVGProps } from 'react'
const LineTrain = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M17.25 2H6.75A2.755 2.755 0 0 0 4 4.75v12.5A2.755 2.755 0 0 0 6.75 20h.29l-.94 1.625 1.3.75L8.77 20h6.46l1.37 2.375 1.3-.75L16.96 20h.29A2.755 2.755 0 0 0 20 17.25V4.75A2.755 2.755 0 0 0 17.25 2M6.75 3.5h10.5c.69 0 1.25.56 1.25 1.25v.75h-13v-.75c0-.69.56-1.25 1.25-1.25M5.5 7h5.75v6H5.5zm7.25 0h5.75v6h-5.75zm4.5 11.5H6.75c-.69 0-1.25-.56-1.25-1.25V14.5h13v2.75c0 .69-.56 1.25-1.25 1.25M8 17.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineTrain }
